import { render, staticRenderFns } from "./AdditionalDescription.vue?vue&type=template&id=5c0ee32d&scoped=true"
import script from "./AdditionalDescription.vue?vue&type=script&lang=js"
export * from "./AdditionalDescription.vue?vue&type=script&lang=js"
import style0 from "./AdditionalDescription.vue?vue&type=style&index=0&id=5c0ee32d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0ee32d",
  null
  
)

export default component.exports